<template>
  <div :style="scaleStyle" class="tooltip-wrapper">
    <div class="tooltip-box">
      <div class="tooltip-body">
        {{ $t('tooltip', { currencyCode: getCurrency, minBet: getMinBet }) }}
      </div>
      <div class="tooltip-close" @click="closeTooltip">
        <div class="cross"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { ACTION } from '@/store/ACTION';
import { Utils } from '@/utils/Utils';

export default Vue.extend({
  name: 'Tooltip',
  data: () => ({
    width: 400
  }),
  computed: {
    ...mapGetters([
      'getAppConfiguration',
      'isTooltipShow',
      'getAchievementCurrency',
      'getAchievementMinBet',
      'getCanvasPosition',
      'hasAchievement',
      'hasFreeBet',
      'getFreeBetCurrencyCode',
      'getFreeBetMinBet',
      'hasTournament',
      'getTournamentMinBet',
      'getTournamentCurrency'
    ]),
    uiScale(): number {
      return this.getAppConfiguration.scale;
    },
    scaleStyle(): { transform: string; top: string; left: string; width: string } {
      return {
        transform: 'translate(-50%, -50%) scale(' + this.uiScale + ')',
        top: 400 * this.uiScale + this.getCanvasPosition.top + 'px',
        left: (this.width / 2 - this.left) * this.uiScale + this.getCanvasPosition.left + 'px',
        width: this.width + 'px'
      };
    },
    getCurrency(): string {
      let currency = '';
      switch (true) {
        case this.hasFreeBet:
          currency = this.getFreeBetCurrencyCode;
          break;
        case this.hasTournament:
          currency = this.getTournamentCurrency;
          break;
        default:
          currency = this.getAchievementCurrency;
      }
      return Utils.formatCurrencyCodeToMili(currency);
    },
    getMinBet(): string {
      switch (true) {
        case this.hasFreeBet:
          return this.getFreeBetMinBet;
        case this.hasTournament:
          return this.getTournamentMinBet;
        default:
          return this.getAchievementMinBet;
      }
    },
    left(): number {
      return this.isTooltipShow ? 0 : this.width + 10 + (this.getCanvasPosition.left * 2) / this.uiScale;
    }
  },
  methods: {
    closeTooltip(): void {
      promoApp.eventEmitter.emit(ACTION.HIDE_TOOLTIP);
    }
  }
});
</script>

<style scoped>
.tooltip-wrapper {
  position: fixed;
  font-family: 'myriadpro-bold', sans-serif;
  transition: all 0.5s ease;
}

.tooltip-box {
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
}

.tooltip-body {
  color: white;
  font-size: 25px;
  flex: 0 0 85%;
  padding: 10px;
}

.tooltip-close {
  flex: 0 0 15%;
  background-color: rgba(0, 0, 0, 0.3);
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tooltip-close:hover {
  background-color: rgba(45, 45, 45, 0.85);
}

.tooltip-close:hover .cross {
  transform: scale(1.1);
}

.tooltip-close:hover .cross::after,
.tooltip-close:hover .cross::before {
  height: 4px;
}

.cross {
  width: 40px;
  height: 40px;
  position: relative;
}

.cross::after {
  content: '';
  width: 100%;
  height: 3px;
  position: absolute;
  top: 20px;
  left: 0;
  background-color: white;
  transform: rotate(-45deg);
  transition: all 0.1s ease;
  border-radius: 5px;
}

.cross::before {
  content: '';
  width: 100%;
  height: 3px;
  position: absolute;
  top: 20px;
  left: 0;
  background-color: white;
  transform: rotate(45deg);
  transition: all 0.2s ease;
  border-radius: 5px;
}
</style>
